export default __webpack_public_path__ + "static/media/bug.0d21ee60.svg";